import React from "react";
import { Outlet } from "react-router-dom";
import { HeaderPortal } from "@/components/src/header-portal/header-portal.component";
import { OrganizationMenu } from "./components/organization-menu.component";

export const OrganizationPage: React.FC = () => {
	return (
		<>
			<HeaderPortal>
				<div className="flex items-center justify-between w-full gap-1">
{/* 					<PageTitle
						title={[{ name: "Mein Labor" }]}
						icon={<CorporateFareIcon style={{ width: "16px", height: "16px", color: "rgb(55, 65, 81)" }} />}
					/> */}
					<OrganizationMenu />
				</div>
			</HeaderPortal>

			<div className="flex-1 overflow-hidden h-full">
				<div className="h-full w-full overflow-auto">
					<Outlet />
				</div>
			</div>
		</>
	);
};